var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-detail"},[_c('el-skeleton',{attrs:{"loading":_vm.loading,"animated":""}},[[_c(_vm.nowComponent,{tag:"component",staticStyle:{"margin-top":"20px"}})]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }